import { render, staticRenderFns } from "./LogoGroup.vue?vue&type=template&id=20eff889&scoped=true&"
import script from "./LogoGroup.vue?vue&type=script&lang=js&"
export * from "./LogoGroup.vue?vue&type=script&lang=js&"
import style0 from "./LogoGroup.vue?vue&type=style&index=0&id=20eff889&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eff889",
  null
  
)

export default component.exports